import React from 'react'
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'
import { PrismicRichText } from '@prismicio/react'

const Counter = ({ slice }) => {
  return (
    <section className='component-counter mx-auto max-w-screen-xl p-6'>
      <div className='prose max-w-full md:prose-lg'>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
        {({ isVisible }) => (
          <div className='flex flex-col items-center justify-evenly py-2 md:flex-row'>
            {slice.items.map((counter, index) => {
              return (
                <div className='flex flex-col py-4 text-center leading-none' key={`counter-${index}`}>
                  {isVisible ? (
                    <CountUp
                      className=' text-4xl font-bold text-secondary md:text-6xl'
                      delay={slice.primary.delay}
                      end={counter.final_number}
                      suffix={counter.suffix || ''}
                      prefix={counter.prefix || ''}
                      separator=','
                      decimal='.'
                      duration={slice.primary.duration}
                    />
                  ) : null}
                  <div>
                    <span className='text-primary'>
                      <PrismicRichText field={counter.title.richText} />
                    </span>
                    <PrismicRichText field={counter.text.richText} />
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </VisibilitySensor>
    </section>
  )
}

export default Counter
